import React from 'react';
import { Box, Typography } from '@mui/material';

interface RateSummaryProps {
    rate: number;
    isCaseRate: boolean;
    applyMultiProcedureDisc: boolean;
}

export const RateSummary: React.FC<RateSummaryProps> = ({
    rate,
    isCaseRate,
    applyMultiProcedureDisc
}) => {
    if (rate <= 0) return null;

    return (
        <Box sx={{ p: 2, bgcolor: 'grey.50', borderRadius: 1, border: '1px solid', borderColor: 'grey.200' }}>
            <Typography variant="subtitle2" gutterBottom>
                Rate Summary
            </Typography>
            <Typography variant="body2" sx={{ fontFamily: 'monospace', mt: 1 }}>
                <strong>${rate.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong>
                {isCaseRate ? ' (Case Rate)' : ' (Per Procedure)'}
            </Typography>
            {applyMultiProcedureDisc && (
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    Subject to multi-procedure discount
                </Typography>
            )}
        </Box>
    );
};
